import { t } from '@kso/ui/lib/config/locale';

var errors = {
  'groupNumLimit': t('utils.errors.txt0'),
  'groupLengthTooShort': t('utils.errors.txt1'),
  'illegalGroupName': t('utils.errors.txt2'),
  'groupLengthTooLong': t('utils.errors.txt3'),
  'userNotLogin': t('utils.errors.txt4'),
  'InvalidArgument': t('utils.errors.txt5'),
  'ERR_SERVER_EXCEPTION': t('utils.errors.txt6'),
  'ServerError': t('utils.errors.txt7'),
  'LicenseNotFound': t('utils.errors.txt8'),
  'LicenseExpired': t('utils.errors.txt9'),
  'permissionDenied': t('utils.errors.txt10'),
  'DomainExist': t('utils.errors.txt11'),
  'CompanymMemberNotExist': t('utils.errors.txt12'),
  'InvalidCompanyName': t('utils.errors.txt13'),
  'CompanyNameTooLong': t('utils.errors.txt14'),
  'UserAlreadyExists': t('utils.errors.txt15'),
  'DeptNotEmpty': t('utils.errors.txt16'),
  'GroupMemberExists': t('utils.errors.txt17'),
  'GroupMemberLimit': t('utils.errors.txt18'),
  'InvalidAccount': t('utils.errors.txt19'),
  'downloadTooDeep': '',
  'groupNotExist': t('utils.errors.txt21'),
  'teamLinkNotExist': t('utils.errors.txt22'),
  'notPersonalUser': t('utils.errors.txt23'),
  'UserNotExists': t('utils.errors.txt24'),
  'fileNameLengthExceed': t('utils.errors.txt25'),
  'fileNameConflict': t('utils.errors.txt26'),
  'fileNotExists': t('utils.errors.txt27'),
  'notGroupMember': t('utils.errors.txt28'),
  'illegalFname': t('utils.errors.txt29'),
  'illegalLinkFolderName': t('utils.errors.txt30'),
  'fileNameEmpty': t('utils.errors.txt31'),
  'moveFilePermission': t('utils.errors.txt32'),
  'moveFileSelfPermission': t('utils.errors.txt33'),
  'lightLinkExist': t('utils.errors.txt34'),
  'LIGHT_LINK_NOT_EXIST': t('utils.errors.txt35'),
  'SecretGroupPermissionDenied': t('utils.errors.txt36'),
  'checkPerFail': t('utils.errors.txt37'),
  'noFolderOperatePermission': t('utils.errors.txt38'),
  'noNewFilePermission': t('utils.errors.txt39'),
  // account
  'MustHasOneBind': t('utils.errors.txt40'),
  'apiRateLimitExceede': t('utils.errors.txt41'),
  'SMSLimitReached': t('utils.errors.txt42'),
  // 'InvalidArgument': '必填字段',
  'InvalidPhone': t('utils.errors.txt43'),
  'PhoneAlreadyInUsed': t('utils.errors.txt44'),
  'CellPhoneAlreadyInUsed': t('utils.errors.txt44'),
  'InvalidEmail': t('utils.errors.txt45'),
  'EmailAlreadyInUsed': t('utils.errors.txt46'),
  'InvalidBindCode': t('utils.errors.txt47'),
  'EmailAlreadyExists': t('utils.errors.txt48'),
  'must has an email account': t('utils.errors.txt49'),
  'invalid verify code': t('utils.errors.txt50'),
  'PasswordWeak': t('utils.errors.txt51'),
  'UserHasBindedPhone': t('utils.errors.txt52'),
  'CellPhoneBind': t('utils.errors.txt53'),
  'value of required argument can\'t not be empty': t('utils.errors.txt54'),
  'InvalidEmailCode': t('utils.errors.txt55'),
  'InvalidSMSCode': t('utils.errors.txt56'),
  'UserHasBindedEmail': t('utils.errors.txt57'),
  'EmailNotExists': t('utils.errors.txt58'),
  'InvalidToken': t('utils.errors.txt59'),
  'InvalidNickname': t('utils.errors.txt60'),
  'wrongPassword': t('utils.errors.txt61'),
  'chkCodeReset': t('utils.errors.txt62'),
  'commentLengthTooLong': t('utils.errors.txt63'),
  '_shareFail': t('utils.errors.txt64'),
  'commentTooLong': t('utils.errors.txt65'),
  'moveFilesFail': t('utils.errors.txt66'),
  'linkClosed': t('utils.errors.txt67'),
  'FileNoExists': t('utils.errors.txt68'),
  'IPCError': t('utils.errors.txt69'),
  'IOError': t('utils.errors.txt70'),
  'batchDownloadTooDeep': t('utils.errors.txt71'),
  'batchDownloadFailed': t('utils.errors.txt72'),
  'batchDownloadEmptyFolder': t('utils.errors.txt73'),
  'batchDownloadEmpty': t('utils.errors.txt74'),
  'fileSearchNoPermission': t('utils.errors.txt75'),
  'copyFileFail': t('utils.errors.txt76'),
  'noCopyMultiFolders': t('utils.errors.txt77'),
  'copyTooDeep': t('utils.errors.txt78'),
  'fileTaskFailed': t('utils.errors.txt79'),
  'fileTaskNumLimit': t('utils.errors.txt80'),
  'fileTaskNotExist': t('utils.errors.txt81'),
  'fileTaskDuplicated': t('utils.errors.txt82'),
  // usercenter
  'NicknameTooLong': t('utils.errors.txt83'),
  'InvalidSsid': t('utils.errors.txt84'),
  'userContracted': t('utils.errors.txt85'),
  'fileImportSameAccount': t('utils.errors.txt86'),
  'HaveNotVerify': t('utils.errors.txt87'),
  'InvalidVerifyCode': t('utils.errors.txt88'),
  'SsidIsMissing': t('utils.errors.txt89'),
  'SsidParamError': t('utils.errors.txt90'),
  'GetAccountMergeUserInfoFailed': t('utils.errors.txt91'),
  'ReportAccountMergeFailed': t('utils.errors.txt92'),
  'CanNotMergeUsersFromDiffrentCompany': t('utils.errors.txt93'),
  'CanNotMergerUsersFromThisCompany': t('utils.errors.txt94'),
  'QueryPermittedDocumentFaild': t('utils.errors.txt95'),
  'CanNotGetLoginUserInfo': t('utils.errors.txt96'),
  'InconsistentAccount': t('utils.errors.txt97'),
  'IrregularOauthBinded': t('utils.errors.txt98'),
  // 协作组
  'ErrLinkShareGroupNotFound': t('utils.errors.txt99'),
  'ErrGroupCountExceedLimit': t('utils.errors.txt100'),
  'ErrLinkShareGroupMemberNotFound': t('utils.errors.txt101'),
  // join
  'ContainSensitiveWords': t('utils.errors.txt102'),
  'GroupNameContainSensitiveWords': t('utils.errors.txt103'),
  'NetworkError': t('utils.errors.txt104'),
  'UnknownError': t('utils.errors.txt105'),
  'TeamAppNameLengthExceed': t('utils.errors.txt106'),
  'TeamAppNameIllegal': t('utils.errors.txt107')
};

export { errors as default };
